<template>
	<div>
		<div class="dis-fle ali-cen">
			<div class="left bor">
				<div class="title tx-18">{{ $t('划转') }}</div>
				<div class="form-item" style="margin-top: 30px;">
					<div class="label">{{ $t('从') }}</div>
					<div class="value">
						<el-select v-model="form.from_account" :placeholder="$t('请选择')" style="width: 100%;">
							<el-option v-for="item in fromList" :key="item.code" :label="item.name" :value="item.code">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="form-item">
					<div class="label">{{ $t('至') }}</div>
					<div class="value">
						<el-select v-model="form.to_account" :placeholder="$t('请选择')" style="width: 100%;">
							<el-option v-for="item in toList" :key="item.code" :label="item.name" :value="item.code">
							</el-option>
						</el-select>
					</div>
				</div>

				<div class="form-item" style="margin-top: 30px;">
					<div class="label">{{ $t('币种') }}</div>
					<div class="value">
						<el-select v-model="form.coin_id" :placeholder="$t('请选择')" style="width: 100%;">
							<el-option v-for="item in coinList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>

				<div class="form-item">
					<div class="label">{{ $t('划转数量') }}</div>
					<div class="value">
						<el-input v-model="form.amount" :placeholder="$t('请输入划转数量')">
							<template slot="suffix">
								<div class="dad" @click="allCk">{{ $t('全部') }}</div>
							</template>
						</el-input>
					</div>
				</div>

				<div class="txt-14">{{ $t('余额') }}: {{ balance }}</div>

				<el-button class="btn" type="primary" @click="submit">{{ $t('划转') }}</el-button>
			</div>
			<div class="right">
				<div class="hover-img">
					<img alt="" src="https://api.shengge975.com/upload/1744730195821558.png">
				</div>
			</div>
		</div>
		<tableMode ref="tableModeRef"></tableMode>
	</div>
</template>

<script>
import tableMode from './table.vue';
import apis from '@/http/api'
import { get, post } from '@/http/request'
export default {
	components: {
		tableMode
	},
	data() {
		return {
			transferData: {
				coins: [],
				wallet_list: [],
			},
			form: {
				from_account: '', //转出账户
				to_account: '', //转入账户
				amount: '', //金额
				coin_id: '', //货币id
			},
		};
	},
	watch: {
		'form.from_account'() {
			this.form.to_account = ''
		},
	},
	computed: {
		balance() {
			let arr = this.transferData.wallet_list || []
			let code = this.form.from_account
			let list = arr.filter(item => item.code === code)
			if (list.length > 0) {
				return list[0].value
			}
			return 0
		},
		fromList() {
			let arr = this.transferData.wallet_list || []
			let code = this.form.to_account
			return arr.filter(item => item.code !== code)
		},
		toList() {
			let arr = this.transferData.wallet_list || []
			let code = this.form.from_account
			return arr.filter(item => item.code !== code)
		},
		coinList() {
			let arr = this.transferData.coins
			if (!Array.isArray(arr)) {
				return [arr]
			} else {
				return arr || []
			}
		},
	},
	methods: {
		init() {
			this.getData()

			this.$nextTick(() => {
				this.initTable()
			})
		},
		getData() {
			get(apis.transferData, {}).then(res => {
				if (res.code != 1) return
				this.transferData = res.data

				if (this.transferData.wallet_list.length > 0) {
					this.form.from_account = this.transferData.wallet_list[0].code
				}
			})
		},
		submit() {
			post(apis.moneyTransfer, this.form).then(res => {
				if (res.code != 1) return
				this.form.amount = ''
				this.$notify.success(res.msg)

				this.init()
			})
		},
		allCk() {
			this.form.amount = this.balance
		},
		initTable() {
			this.$refs.tableModeRef.init()
		}
	},
};
</script>
<style lang="scss" scoped>
.left {
	width: 520px;

	::v-deep .el-input--small .el-input__inner {
		height: 40px;
		line-height: 40px;
	}

	.title {
		// margin-bottom: 20px;
	}

	.txt-14 {
		margin: 10px 0px 50px;
	}

	.btn {
		width: 100%;
		line-height: 38px;
		height: 38px;
		border-radius: 50px;
		font-size: 16px;
		padding: 0px;
	}

	.form-item {
		.label {
			font-size: 14px;
			line-height: 32px;
		}

		.value {
			margin-bottom: 10px;
		}
	}

	.dad {
		height: 100%;
		display: flex;
		align-items: center;
		color: #07ecfe;
		cursor: pointer;
		padding-right: 16px;
	}
}

.right {
	flex: 1;
	margin-left: 30px;
	border-radius: 12px;
	background: url('~@/assets/img-pc/125.e20cb355.png') no-repeat;
	background-size: 100% 100%;
	min-height: 560px;

	.hover-img {
		width: 80%;
		height: 100px;
		margin: 143px auto 0;
		border-radius: 12px;
		background: rgba(44, 44, 52, .23);
		-webkit-backdrop-filter: blur(6px);
		backdrop-filter: blur(6px);
		font-size: 50px;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			height: 90px;
		}
	}
}

.bor {
	border: 2px solid #2c2c3e;
	padding: 20px 30px 30px;
	border-radius: 12px;
}
</style>